<template>
  <div class="head_box">
    <div class="head" >
      <div class="widthBox acea-row row-between row-middle">
        <div class="logo">
          <router-link to="/" @click.native="set_nav_index(0)">

            <img :src="info.web_info.web_header_logo_url" alt="">
          </router-link>
        </div>
        <div class="nav">
          <div class="nav_box" v-for="(item, index) in nav" @mouseover="setShow(index)"
            @mouseout="setShow(index)" :key="index" style="position: relative;">
            <router-link v-if="item.url == ''" class="info active_txt disabled-link" :class="head_nav_index == index ? 'warn_txt' : ''" :to="item.url" @click.native="item.sub_nav_list.length != 0 ? '' : set_nav_index(index),topBtn(item.video_url,item.image_pc_url)">
              {{ item.name }}
            </router-link> 
            <router-link v-else class="info active_txt" :class="head_nav_index == index ? 'warn_txt' : ''" :to="item.url" @click.native="item.sub_nav_list.length != 0 ? '' : set_nav_index(index),topBtn(item.video_url,item.image_pc_url)">
              {{ item.name }}
            </router-link> 

            <div v-show="item.sub_nav_list.length != 0 && item.show" class="item">
              <router-link v-for="(item2, index2) in item.sub_nav_list" :key="index2" :class="item2.url == '' ? 'disabled-link' : ''" :to="item2.url" @click.native="topBtn(item2.video_url,item2.image_pc_url),set_nav_index(index)"
                class="nav_children info active_txt">{{ item2.name }}</router-link>
            </div>
          </div>
        </div>
        <div class="btn acea-row row-middle">
          <a class="cursor f-14 warn_txt warn_border" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a>
          <div class="cursor language_btn acea-row row-middle" @mouseover="(language = true)"
            @mouseout="(language = false)">
            <img class="icon_16" src="@/assets/language.png" alt="">
            <span class="f-12">{{ lang }}</span>
            <img class="icon_16" src="@/assets/arrow_bottom.png" alt="">
          </div>
          <div v-show="language" @mouseover="(language = true)" @mouseout="(language = false)" class="language f-14">
            <div v-for="item in lang_list" :key="item.key" class="item cursor" :class="lang == item.name ? 'center' : ''" @click="to_url(item.key)">
              <div class="txt1 f-14">{{item.country}}</div>
              <div class="txt2 f-12">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="head_mini">
      <div class="head_top">
        <router-link to="/">
          <img class="logo" :src="info.web_info.web_header_logo_url" alt="">
        </router-link>
        <div class="head_top_right">

          <div class="btn acea-row row-middle" style="margin-right: 20px;">
            <!-- <a class="cursor f-14 warn_txt warn_border" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a> -->
            <div class="cursor language_btn acea-row row-middle" @click="(language = !language)" >
              <img class="icon_16" src="@/assets/language.png" alt="">
              <span class="f-12">{{ lang }}</span>
              <img class="icon_16" src="@/assets/arrow_bottom.png" alt="">
            </div>

            <div v-show="language" class="language f-14" style="z-index: 9;">
              <div v-for="item in lang_list" :key="item.key" class="item cursor" :class="lang == item.name ? 'center' : ''" @click="to_url(item.key)">
                <div class="txt1 f-14">{{item.country}}</div>
                <div class="txt2 f-12">{{item.name}}</div>
              </div>
            </div>

          </div>

          <img v-show="!menu" @click="(menu = true)" class="menu cursor" src="@/assets/more.png" alt="">
          <img v-show="menu" @click="(menu = false)" class="menu cursor" src="@/assets/close.png" alt="">
        </div>
      </div>
      <div v-show="menu" class="head_bottom">
        <div class="nav_box" v-for="(item, index) in nav" :key="index" style="position: relative;" @click="item.url == '' ? setShow(index): topBtn(item.video_url,item.image_pc_url) ">
          <router-link v-if="item.url == ''" class="disabled-link" :class="item.show ? 'gary' :''" :to="item.url">
            {{ item.name }}
          </router-link>
          <router-link v-else class="" :class="item.show ? 'gary' :''" :to="item.url">
            {{ item.name }}
          </router-link>
          <div v-show="item.sub_nav_list && item.show" class="item">
            <div v-for="(item2, index2) in item.sub_nav_list" :key="index2"  @click="topBtn(item2.video_url,item2.image_pc_url)">
              <router-link :to="item2.url" class="nav_children " :class="item2.url == '' ? 'disabled-link' : ''">{{ item2.name }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "../i18n"
export default {
  data() {
    return {
      nav: [],
      language: false,
      lang: "English",
      menu: false
    }
  },
  props:{
    info:{
      default:{web_info:null},
      type:Object
    },
    nav:{
      default:[],
      type:Array
    },
    lang_list:{
      default:[],
      type:Array
    },
  },
	computed: {
    
	},
  created() {
    const paramsString = window.location.search.substring(1);
    const params = new URLSearchParams(paramsString);
    const lang = params.get("lang"); // "John"
    this.lang_list.forEach(element => {
      if (lang == element.key) {
        this.lang = element.name
      }
    });
    if (lang == null) {
      this.lang = this.lang_list[0].name
    }
  },
  mounted() {
    const paramsString = window.location.search.substring(1);
    const params = new URLSearchParams(paramsString);
    const lang = params.get("lang"); // "John"
    i18n.locale = lang ? lang : this.lang_list[0].key;
  },
  
  computed: {
    head_nav_index(){
      return this.$store.state.head_nav_index
    },
  },
  methods: {
    setShow(index){
      let {nav} = this;
      this.$set(this.nav[index],'show',!nav[index].show)
      this.$forceUpdate();
    },
    to_url(lang) {
      console.log(this.$route.query)
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.lang = lang;
      let parameter = "";
      for(let i in query){
        parameter += parameter == "" ? "?"+i+"="+query[i] : "&"+i+"="+query[i]
      }
      this.$router.push(this.$route.path + parameter)
      this.$router.go(0)
			document.body.scrollIntoView();
    },
    set_nav_index(index){
      this.$store.state.head_nav_index = index;
      sessionStorage.setItem("head_nav_index",index)
			document.body.scrollIntoView();
      
    },
		topBtn(video,bannerS) {
      // this.$store.state.video = video;
      // sessionStorage.setItem("video",video)
      // this.$store.state.bannerS = bannerS;
      // sessionStorage.setItem("bannerS",bannerS)
      this.menu = false
			document.body.scrollIntoView();
		},
    scrollIntoView(){
			document.body.scrollIntoView();
    }
  }
}
</script>


<style scoped="scoped" lang="scss">
.disabled-link {
  pointer-events: none;
  text-decoration: none;
}
.head_box {
  background: rgba($color: #fff, $alpha: 1);
  height: 80px;
}

.head_mini {
  display: none;
  background: rgba($color: #fff, $alpha: 1);
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;

  .head_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    box-sizing: border-box;
    height: 48px;
    .head_top_right{
      display: flex;
      .btn{
        position: relative;
      }
      .language{
        position: absolute;
        top:30px;
        left: -20px;
        width: auto;
        background: #fff;
        
        .item {
          padding: 8px 24px;
          padding-top: 16px;
          width: 100%;
          background: #fff;
          text-align: left;
          border-top: 1px solid rgba($color: #999, $alpha: 0.1);
          border-bottom: 1px solid rgba($color: #999, $alpha: 0.1);
          // margin-bottom: 8px;

          .txt1 {
            color: #666666;
            margin-bottom: 4px;
          }

          .txt2 {
            color: #999;
          }

          &.center {
            text-align: center;

            .txt1 {
              color: #1A1A1A;
            }

            .txt2 {
              color: #B50900;
            }
          }
        }
      }
    }
    .logo {
      width: 96px !important;
    }

    .menu {
      width: 24px;
    }
  }

  .head_bottom {
    background: #F5F5F5;
    height: 9999px;
    padding: 40px;
    .nav_box{
      margin-bottom: 20px;
      a{
        font-size: 20px;
        color: #1A1A1A;
      }
      .gary{
        color: #666666;
      }
      .item{
        margin-top: 20px;
        div{
          margin-bottom: 16px;
          text-indent: 2em;
        }
        a{
          width: 100%;
          text-indent: 2em;
        }
      }
    }
  }
}
.warn_txt{
  font-weight: 700;
}
.head {
  height: 80px;
  // backdrop-filter: blur(40px);
  background: rgba($color: #fff, $alpha: 1);
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  .widthBox {
    height: 80px;

    .logo {
      width: 162px;

      img {
        width: 100%;
      }
    }

    .nav {
      display: flex;
      justify-content: center;

      a {
        height: 80px;
        padding: 0 25px;
        display: block;
        line-height: 80px;
        text-align: center;
      }

      .nav_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }

      .item {
        position: absolute;
        top: 80px;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        white-space: nowrap;
        box-shadow: 5px 0px 5px rgba($color: #000000, $alpha: 0.5);

        .nav_children {
          height: auto;
          line-height: 24px;
          padding: 0;
          margin-bottom: 10px;
        }

        .nav_children:last-child {
          margin-bottom: 0;
        }
      }
    }

    .btn {
      height: 80px;

      .warn_txt {
        padding: 8px 12px;
        margin-right: 16px;
        border-radius: 4px;
      }

      span {
        color: #666;
      }

      .language_btn {
        height: 100%;

        img:nth-child(1) {
          margin-right: 5px;
        }
      }

      .language {
        position: absolute;
        width: 240px;
        background: #fff;
        top: 100%;
        transform: translateX(-22%);
        padding-top: 8px;

        .item {
          width: 100%;
          padding: 8px 24px;
          box-sizing: border-box;
          text-align: left;
          border-top: 1px solid rgba($color: #999, $alpha: 0.1);
          border-bottom: 1px solid rgba($color: #999, $alpha: 0.1);
          margin-bottom: 8px;

          .txt1 {
            color: #666666;
            margin-bottom: 4px;
          }

          .txt2 {
            color: #999;
          }

          &.center {
            text-align: center;

            .txt1 {
              color: #1A1A1A;
            }

            .txt2 {
              color: #B50900;
            }
          }
        }
      }
    }
  }
}
@media screen and(max-width:1000px) {
  .head .widthBox .nav a{
    padding: 0 10px;
  }
}

@media screen and(max-width:900px) {
  .logo {
    width: 100px !important;
  }
}

@media screen and(max-width:768px) {
  .head {
    display: none;
  }
  .head_box{
    height: 48px;
  }
  .head_mini {
    display: block;
  }
}

@media screen and(max-width:350px) {
  .head_bottom{
    padding: 20px !important;
  }
}
</style>
